import { render, staticRenderFns } from "./SaleOrderItem.vue?vue&type=template&id=a700a7f6&scoped=true&"
import script from "./SaleOrderItem.vue?vue&type=script&lang=js&"
export * from "./SaleOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderItem.vue?vue&type=style&index=0&id=a700a7f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a700a7f6",
  null
  
)

export default component.exports